import { render, staticRenderFns } from "./Reversions.vue?vue&type=template&id=fd3dc3dc&"
import script from "./Reversions.vue?vue&type=script&lang=ts&"
export * from "./Reversions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports